/* SALE CLOCK */
var ShapifyToday = new Date();

if (localStorage.getItem("offerEndsIn") === null) {
  localStorage.setItem("offerEndsIn", ShapifyToday);
  
  var userOfferStartDate = new Date(localStorage.getItem("offerEndsIn"));
  var ShapifySaleEnds = userOfferStartDate;
  
  ShapifySaleEnds.setDate(ShapifySaleEnds.getDate() + 3);
} else {
  var userOfferStartDate = new Date(localStorage.getItem("offerEndsIn"));
  var ShapifySaleEnds = userOfferStartDate;
  
  ShapifySaleEnds.setDate(ShapifySaleEnds.getDate() + 3);

  if (ShapifySaleEnds.getTime() < ShapifyToday.getTime()) {
    localStorage.setItem("offerEndsIn", ShapifyToday);
  }
}

var shapify_count_down_maindiv = jQuery(".discountWrapper");
var shapify_count_down_el = jQuery(".saleClock .clock");

var shapify_day_label = "day";
var shapify_days_label = "days";
var shapify_hour_label = "hour";
var shapify_hours_label = "hours";
var shapify_minute_label = "min";
var shapify_minutes_label = "mins";
var shapify_second_label = "sec";
var shapify_seconds_label = "secs";

if(typeof shapify_overwrite_sales_clock_text == 'function')
{
  shapify_overwrite_sales_clock_text();
}

ShapCountdown();
setInterval("ShapCountdown()",1000);

function ShapCountdown(){
  var day_label = shapify_day_label, hour_label =  shapify_hour_label, minute_label = shapify_minute_label, second_label=shapify_second_label;
  var days = 0;var hours = 0;var minutes = 0;var seconds = 0; 
  var difference = 0; 

  difference = ShapifySaleEnds - ShapifyToday; 
  days = Math.floor(difference/(1000*60*60*24));

  difference = difference - (days * 1000*60*60*24);
  hours = Math.floor(difference/(1000*60*60));

  difference = difference - (hours * 1000*60*60);
  minutes = Math.floor(difference/(1000*60));

  difference = difference - (minutes * 1000*60);
  seconds = Math.floor(difference/(1000));

  if(days != 1) day_label = shapify_days_label;
  if(hours != 1) hour_label = shapify_hours_label;
  if(minutes != 1) minute_label = shapify_minutes_label;
  if(seconds != 1) second_label = shapify_seconds_label;

  if(days>=0)  {
    if(shapify_count_down_el){ 
      shapify_count_down_el.html(`${days} ${day_label} &nbsp;&nbsp;&nbsp;${hours} ${hour_label} &nbsp;&nbsp;&nbsp;${minutes} ${minute_label}`) ;
    }
  }

  ShapifyToday.setSeconds(ShapifyToday.getSeconds() + 1);

}
/* SALE CLOCK ENDS */

// Hide Discount bar
jQuery(document).on('click', '.close', function(e) {
  e.preventDefault();
  if (jQuery(window).width() >= 768) {
    jQuery('.discountTopDesk').css('cssText','display:none !important');
    jQuery('.saleTopDesk').css('cssText','display:flex !important');
  } else {
    jQuery('.discountTopMob').css('cssText','display:none !important');
    jQuery('.saleTopMob').css('cssText','display:block !important');
  }
});
// Hide Discount bar ends

// Show Popup
jQuery(document).on('click', '.saleText a', function(e) {
  e.preventDefault();
  jQuery('.klaviyo-popup').show();
});
// Show Popup ends